import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { MedalliaFacade } from '@core/medallia/facades/medallia.facade';

export const provideMedallia = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      inject(MedalliaFacade);
    }),
  ]);
